import { Logo } from "./Logo";
import { Mail, Phone, MapPin } from "lucide-react";

const COLS = [
  { title: "Produk", links: ["Fitur", "Harga", "Cara Kerja", "Keamanan Data"] },
  { title: "Perusahaan", links: ["Tentang Kami", "Blog Edukasi", "Karier", "Mitra Reseller"] },
  { title: "Dukungan", links: ["Pusat Bantuan", "Dokumentasi", "Status Sistem", "Hubungi Kami"] },
];

export const Footer = ({ onLogin }) => {
  return (
    <footer className="relative border-t border-cyan-500/10 bg-[#080C16]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Logo />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Platform manajemen sekolah SaaS multi-tenant. Satu sistem cerdas untuk akademik, keuangan, dan komunikasi sekolah modern di Indonesia.
            </p>
            <div className="mt-6 space-y-2 text-sm text-slate-400">
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-cyan-400" /> halo@sahabatpena.id</div>
              <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-cyan-400" /> +62 812-0000-0000</div>
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-cyan-400" /> Pekanbaru, Riau, Indonesia</div>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-white">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <button className="text-sm text-slate-400 transition-colors hover:text-cyan-400">{l}</button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Sahabat PENA. Seluruh hak cipta dilindungi.</p>
          <div className="flex items-center gap-5 text-xs text-slate-500">
            <button className="hover:text-cyan-400">Kebijakan Privasi</button>
            <button className="hover:text-cyan-400">Syarat & Ketentuan</button>
            <button onClick={onLogin} className="hover:text-cyan-400" data-testid="footer-login-btn">Login Sekolah</button>
          </div>
        </div>
      </div>
    </footer>
  );
};
